import React from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../../util/utils';

import {IconoirEdit} from '@ey-xd/motif-icon';

import OutputText from '@ey/canvascoreservices/OutputText';
import Icon from '@ey/canvascoreservices/Icon';

import StyledDraftIndicator from './StyledDraftIndicator';

const DraftIndicator = () => {
	return (
		<StyledDraftIndicator className='draft'>
			<Icon src={IconoirEdit} />
			<OutputText body2 light>
				{labels.draftlabel}
			</OutputText>
		</StyledDraftIndicator>
	);
};

DraftIndicator.propTypes = {
	name: PropTypes.string
};

DraftIndicator.defaultProps = {
	name: null
};

export default DraftIndicator;
